// 24 hours in milliseconds (1 day)
export const COMPANY_STALE_TIME = 1000 * 60 * 60 * 24

// 24 hours in milliseconds (1 day)
export const GC_TIME = 1000 * 60 * 60 * 24

// Key for obtaining company personalization from localStorage
export const LOCAL_STORAGE_KEY_COMPANY_PERSONALIZATION = 'company'
